module.exports = __webpack_public_path__ + "img/Group 279.9cd8aeba.svg";